import styled from "styled-components";
import React from "react";
import { Colors } from "../constants/colors";

export const HelpButton = styled.button<{ onClick?: () => void; children?: React.ReactNode }>(({ theme }) => ({
    position: "absolute" as const,
    top: theme.spacing.medium,
    right: theme.spacing.medium,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 14,
    paddingRight: 14,
    borderRadius: 18,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: Colors.rust20,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
